import type { FPlusContextScopeOutput } from '@festina/configuration-general-types/configuration'

import { useFPlusScopeFilterValue } from '../../context/fPlusScopeFilterValueContext'
import { ConfigurationItemIcon } from '../configurationItemIcon/ConfigurationItemIcon'
import { FPlusContextItem } from './FPlusContextItem'
import { HoverMenuList } from './HoverMenuList'

type FPlusContextListProps = {
  contexts: FPlusContextScopeOutput[]
}

export const FPlusContextList = ({ contexts }: FPlusContextListProps) => {
  const { filterValue } = useFPlusScopeFilterValue()

  return (
    <HoverMenuList
      filterValue={filterValue}
      elements={contexts}
      renderLabel={(context) => (
        <div className="flex grow justify-center gap-x-2 text-base">
          <ConfigurationItemIcon type="template" />
          {context.typeName}
        </div>
      )}
      renderHover={(context) => <FPlusContextItem context={context} />}
    />
  )
}
